import { createDecorator } from 'vue-class-component';

/**
 * Binds a vue component's data field or computed getter/setter to a localstorage entry.
 * Value is initialized in the created() hook, which is try-catched to silence errors.
 *
 * @param {string} storageKey - The key to store the value under
 * @param {boolean} deep - Use [deep] option on Vue.watch
 * @param {function(any):string} encoder - Value to string converter, defaults ot JSON.stringify
 * @param {function(string):any} decoder - String to value converter, defaults to JSON.parse
 */
export function LocalStorageBound(
    storageKey,
    { deep = false, encoder = JSON.stringify, decoder = JSON.parse } = {},
) {
    return createDecorator((options, key) => {
        (options.mixins || (options.mixins = [])).push({
            created() {
                try {
                    const stored = localStorage.getItem(storageKey);
                    if (stored !== null) {
                        this[key] = decoder(stored);
                    }
                } catch {
                    /* Empty on purpose */
                }
            },
            watch: {
                [key]: {
                    handler: function(value) {
                        const encoded = encoder(value);
                        localStorage.setItem(storageKey, encoded);
                    },
                    deep,
                },
            },
        });
    });
}
